import { useContext } from 'react';
import { Buttons, ModalContext, Modals, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { showChat } from 'Services/chat';
import useTranslation from 'Hooks/useTranslation';
import { useFetchGetUserClabe } from 'Containers/Account/components/AccountProfile/hooks';
import { lottiesPaths } from 'Constants/lottiesPaths';
import { TaxScreenType } from 'Types/common';
import ResultInfo from '../ResultInfo';
import * as Styled from '../styles';
import DashboardClabeForm from '../DashboardClabeForm';
import { CLABE } from '../utils';

const SendDevolution = ({ tax: { taxYear, filingInfo } }: TaxScreenType): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const { data } = useFetchGetUserClabe();
  const { showModal, hideModal } = useContext(ModalContext);

  const handleClick = (): void => {
    showModal({
      comp: (
        <Modals.Centered maxSize="XL" hasClose onClose={hideModal}>
          <DashboardClabeForm clabeUser={data?.CLABE} />
        </Modals.Centered>
      ),
    });
  };

  return (
    <Styled.InfoContainer
      justify="center"
      direction="column"
      align="center"
      gap="dimension_08"
      fullHeight
    >
      <Text size="L_L_S" color="dark" type="headline">
        {taxYear}
      </Text>
      <Text type="paragraphs" size="L_L_M" color="dark" align="center">
        {t('Dashboard.SendDevolution.message')}
      </Text>
      <Styled.StyledLottie
        options={{
          path: lottiesPaths.WARNING,
          rendererSetting: { progressiveLoad: true },
        }}
      />
      {filingInfo && <ResultInfo filingInfo={filingInfo} />}
      <Text type="paragraphs" color="dark" size="M_L_S" align="center">
        {t(`Dashboard.SendDevolution.title`)}
      </Text>
      <Text type="paragraphs" color="dark" size="S_S_S" align="center">
        {t(`Dashboard.SendDevolution.description`)}
      </Text>
      <Styled.ButtonsWrapper direction="row-reverse" gap="dimension_16">
        <Buttons.Classic
          label={t('Dashboard.SendDevolution.button.label', { context: data?.CLABE && CLABE })}
          mode="primary"
          size="m"
          onClick={handleClick}
        />
        <Buttons.Classic
          size="m"
          mode="light"
          label={t('Dashboard.SendDevolution.help.button')}
          onClick={showChat}
        />
      </Styled.ButtonsWrapper>
    </Styled.InfoContainer>
  );
};

export default SendDevolution;
